import { createSelector } from 'reselect'

export const getCompanyStats = (state: any) => {
  return state.get('persist').companyStats
}

export const companyStatsPending = createSelector(getCompanyStats, companyStats => {
  return companyStats.get('pending')
})
export const companyStatsData = createSelector(getCompanyStats, companyStats => companyStats.get('data'))
export const isCompanyStatsDataEmpty = createSelector(companyStatsData, data => {
  return !!(
    data.get('message') ||
    (!data.get('proTracksStats') && !data.get('topActivity') && !data.get('engagements'))
  )
})
